import { t } from '@lingui/core/macro'
import { Modal, Button } from '@taxonomy-translation/components'

export const CancelUploadConfirmationModal = ({ onClose, onSubmit }) => (
  <Modal onClose={onClose} className="max-w-[600px] px-12 pb-12 pt-11">
    <div>
      <h2 className="font-sans font-bold mb-7 text-xl">{t`Are you sure you want to cancel?`}</h2>
      <p className="text-sm mb-14">
        {t`Are you sure you want to cancel this translation? Any progress you have made creating a new taxonomy translation will be lost.`}
      </p>
      <div className="flex justify-between mt-4">
        <Button onClick={onClose} variant="outline" className="bg-[#F6F8FA] font-normal">
          {t`Continue`}
        </Button>
        <Button variant="warn" onClick={onSubmit}>
          <span className="font-normal">{t`Cancel`}</span>
        </Button>
      </div>
    </div>
  </Modal>
)
